import React from "react";

const SWATCH = {
  none: "linear-gradient(135deg,#3a3f52,#1c1f2b)",
  warm_film: "linear-gradient(135deg,#d9a066,#6b4a2b)",
  golden_hour: "linear-gradient(135deg,#f5c25b,#a35a1c)",
  pastel_romance: "linear-gradient(135deg,#f3d4dc,#c9d6ea)",
  teal_orange: "linear-gradient(135deg,#1b6b73,#e8894a)",
  cool_cinematic: "linear-gradient(135deg,#5b7da8,#1d2a3f)",
  bw_classic: "linear-gradient(135deg,#e5e5e5,#1a1a1a)",
  reference: "conic-gradient(from 90deg,#E6B04E,#00F0FF,#8B5CF6,#E6B04E)",
};

export const PresetGrid = ({ presets, value, onPick, hasReference }) => (
  <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
    {presets.map((p) => {
      const disabled = p.id === "reference" && !hasReference;
      return (
        <button key={p.id} disabled={disabled} onClick={() => onPick(p.id)} data-testid={`color-preset-${p.id}`}
          className={`studio-card p-2.5 text-left transition-[border-color,transform] hover:-translate-y-0.5 disabled:opacity-40 disabled:hover:translate-y-0 ${value === p.id ? "border-[#E6B04E]" : "hover:border-[#3B4259]"}`}>
          <div className="h-10 rounded-md mb-2" style={{ background: SWATCH[p.id] }} />
          <div className="font-semibold text-sm">{p.label}</div>
          <div className="metric-label truncate" style={{ fontSize: 9 }}>{disabled ? "pick an analyzed reference" : p.desc}</div>
        </button>
      );
    })}
  </div>
);
